import styled from "styled-components";
import { MatchUserType } from ".";
import MatchUserButtons from "./MatchUserButtons";
import { useGetChattingRoomInfo } from "@src/hooks/auctionAgent/chat";
import React from "react";
import MatchTakerButtons from "./MatchTakerButtons";
import { useChattingRoomFromContext } from "@src/contexts/ChattingRoomContext";

type MatchButtonBoxProps = {
    userType: MatchUserType;
    matchRequestNo: number;
};

const MatchButtonBox = ({ userType, matchRequestNo }: MatchButtonBoxProps) => {
    const { chattingRoomFromContext } = useChattingRoomFromContext();
    if (!chattingRoomFromContext) return null;
    return (
        <MatchButtonBoxStyle>
            {userType === "user" && (
                <MatchUserButtons matchRequestNo={matchRequestNo} chattingRoomNo={chattingRoomFromContext.chattingRoomNo} />
            )}
            {userType === "taker" && (
                <MatchTakerButtons matchRequestNo={matchRequestNo} chattingRoomNo={chattingRoomFromContext.chattingRoomNo} />
            )}
        </MatchButtonBoxStyle>
    );
};

export default MatchButtonBox;

const MatchButtonBoxStyle = styled.div`
    display: flex;
    gap: 12px;

    .match-button {
        width: 100%;
        height: 100%;
        background-color: #f2f3f6;
        border-radius: 6px;
        padding: 12px;
        font-size: 14px;
        font-weight: 400;
        color: #282828;
    }
`;
